import { useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import useAxios from "../../../services/useAxios";
import toast from "react-hot-toast";

import "./supplier-product.scss";
export default function AddSupplierProduct({
  productList,
  supplierList,
  pageDebounce,
  setUpdater,
}) {
  // request for add supplier product
  const { loading, execute: addSupplierProductApi } = useAxios(
    "api/Insert_Avb_product_for_order"
  );
  // state for open or close modal
  const [showModal, setShowModal] = useState(false);
  // state for save the data
  const [addData, setAddData] = useState({
    product: {},
    supplier: {},
    price: "",
    discount: "",
    total_inventory_count: "",
  });
  // state for validate the data
  const [validate, setValidate] = useState(false);
  // function for set the value to the state
  const inputHandler = (object) => {
    setAddData((prev) => {
      return { ...prev, ...object };
    });
  };
  // function for send add request
  const addSupplierProductFunc = () => {
    let temp = {
      product_id: addData?.product?.value,
      supplier_id: addData?.supplier?.value,
      price: addData?.price,
      discount: addData.discount > 0 ? addData?.price - addData.discount : 0,
      total_inventory_count: addData?.total_inventory_count,
    };
    addSupplierProductApi(temp).then((result) => {
      if (result.status == 1) {
        toast.success("با موفقیت ثبت شد.");
        setShowModal(false);
        setAddData({
          product: {},
          supplier: {},
          price: "",
          discount: "",
          total_inventory_count: "",
        });
        setUpdater((prev) => !prev);
      } else toast.error("ثبت با مشکل مواجه شد لطفا دوباره امتحان کنید.");
    });
  };
  // function for validate the state
  const validation = () => {
    let validate = true;
    if (
      addData.product.value == undefined ||
      addData.supplier.value == undefined ||
      addData.price == "" ||
      addData.discount > addData.price ||
      addData.total_inventory_count == ""
    )
      validate = false;
    if (addData.discount > addData.price)
      toast.error("قیمت باتخفیف از قیمت نباید بیشتر باشد.");
    return validate;
  };

  return (
    <div>
      <button
        onClick={() => {
          setShowModal(true);
          setAddData({
            product: {},
            supplier: {},
            price: "",
            discount: "",
            total_inventory_count: "",
          });
        }}
        className="btn ms-auto bg-success text-light "
      >
        افزودن محصول فروشگاه
      </button>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
        className="add-supplier-product"
      >
        <Modal.Header closeButton className="txt-t1-m">
          افزودن محصول به فروشگاه
        </Modal.Header>
        <Modal.Body style={{ height: "200px" }} className="txt-t1-m">
          <div className="d-flex flex-wrap">
            {" "}
            <div className="col-sm-6 col-12 px-1 my-1">
              <label>انتخاب محصول</label>{" "}
              <Select
                options={productList}
                value={addData?.product}
                onChange={(e) => inputHandler({ product: e })}
                onInputChange={(value) => {
                  pageDebounce(value);
                }}
              />
            </div>
            <div className="col-sm-6 col-12 px-1 my-1">
              <label>انتخاب فروشگاه</label>{" "}
              <Select
                options={supplierList}
                value={addData?.supplier}
                onChange={(e) => inputHandler({ supplier: e })}
              />
            </div>
            <div className="col-4 px-1 my-1">
              {" "}
              <label>قیمت(تومان)</label>
              <input
                className="form-control"
                value={addCommas(addData?.price)}
                onChange={(e) => {
                  if (!isNaN(removeCommas(e.target.value)))
                    inputHandler({ price: removeCommas(e.target.value) });
                }}
              />
            </div>
            <div className="col-4 px-1 my-1">
              {" "}
              <label>قیمت‌باتخفیف(تومان)</label>
              <input
                className="form-control"
                value={addCommas(addData?.discount)}
                onChange={(e) => {
                  if (!isNaN(removeCommas(e.target.value)))
                    inputHandler({ discount: removeCommas(e.target.value) });
                }}
              />
            </div>
            <div className="col-4 px-1 my-1">
              {" "}
              <label>موجودی</label>
              <input
                className="form-control"
                value={addData?.total_inventory_count}
                onChange={(e) => {
                  if (!isNaN(removeCommas(e.target.value)))
                    inputHandler({ total_inventory_count: e.target.value });
                }}
              />
            </div>
            <div
              className="text-danger my-2"
              style={{ display: validate == true ? "block" : "none" }}
            >
              لطفا تمامی مقادیر را پر کنید.
            </div>
            <button
              className="btn bg-success ms-auto my-1 text-light"
              onClick={() => {
                if (validation()) addSupplierProductFunc();
                else setValidate(true);
              }}
            >
              ثبت
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
